// extracted by mini-css-extract-plugin
module.exports = {"dataBarsContainer":"CofnY","showMoreBtn":"CjIjj","dataBarWrapper":"eNPnr","dbwInner":"Hp6ik","dbTopHead":"A5urM","totalSeats":"McQOp","majorityMark":"_9a0Mj","noMinHeight":"BUg7e"};